<template>
  <div style="max-width: 1500px" class="mx-auto">
  </div>
</template>

<script>
export default {
  name: "dashboard"
};
</script>